export class ParticaListLineContent {
	public image: string = "";
	public title: string = "";
	public subtitle: string = "";
	public right: string = "";
	public id: string = "";
	public item: any;
}

// tslint:disable-next-line: max-classes-per-file
export class ParticaListContent {
	public title: string = "";
	public lines: ParticaListLineContent[] = [];
}
